import React from 'react';
import { ArcIconButton, ArcStack, ArcText } from '@src/core/ui';

import { TakeOffActions, TakeOffOrders, TakeOffPreflight } from './components';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetOrderMissionQuery } from '@src/features/order/redux';
import { useDisclosure } from '@src/core/hooks';
import { TakeOffSidebarProps } from './types';
import { ArcSocketContext, ChannelRequestEnum } from '@src/core/socket';
import { ArcDrone } from '@src/core/components';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';



const SidebarTakeOff: React.FC<TakeOffSidebarProps> = (props) => {
  const { viewer } = props;
  const { missionId } = useParams();
  const { open, toggle } = useDisclosure();
  const { data, isLoading } = useGetOrderMissionQuery(missionId);
  const { arcSocket, readyState } = React.useContext(ArcSocketContext);
  const navigate = useNavigate();


  React.useEffect(() => {
    if (!viewer) return;
    
    const socket = arcSocket();
    if (socket === null || socket.readyState !== WebSocket.OPEN) return;
    
    const payload = { type: ChannelRequestEnum.GET_FLIGHT_DATA, data: { missionId } };
    socket.send(JSON.stringify(payload));
        
    return () => {
      const payload = { type: ChannelRequestEnum.STOP_FLIGHT_DATA };
      socket.send(JSON.stringify(payload));
    };
  }, [readyState, viewer, missionId]);

  if (viewer) {
    return (
      <ArcStack spacing={3} marginTop={2}>
        <ArcStack spacing={1}>
          <ArcStack 
            direction='row' 
            alignItems='center'
            justifyContent='start' 
            sx={{ cursor: 'pointer' }}
            onClick={() => navigate(-1)}>
            <ArcIconButton>
              <ArrowBackIosIcon sx={{ fontSize: 20 }}  /> 
            </ArcIconButton>
            <ArcText.h4 fontWeight={500}>Drone Information</ArcText.h4>
          </ArcStack>
          <ArcText.h5 color='text.secondary'>Serial: {data?.drone?.serialNumber}</ArcText.h5>
          <ArcText.h5 color='text.secondary'>Status: Ready for Take Off</ArcText.h5>
        </ArcStack>
        <ArcStack spacing={1}>
          <ArcText.h4 fontWeight={500}>Mission Details</ArcText.h4>
          <ArcText.h5 color='text.secondary'>Mission ID: {missionId}</ArcText.h5>
          <ArcText.h5 color='text.secondary'>Orders: {data?.orders?.length ?? 0}</ArcText.h5>
        </ArcStack>
      </ArcStack>
    );
  }

  return (
    <ArcStack>

      <ArcStack direction='row' alignItems='center' spacing={1}>
        <ArcText.h3 fontWeight={500} marginTop={2}>Preflight Checklist</ArcText.h3>
      </ArcStack>

      <ArcText.h5 marginTop={'20px'} fontWeight={500}>MISSION</ArcText.h5>

      <TakeOffOrders
        isLoading={isLoading} 
        orders={data?.orders ?? []} 
      />

      <ArcText.h5 marginTop='24px' fontWeight={500}>ASSIGNED DRONE</ArcText.h5>
      {data?.drone && <ArcDrone.primary
        drone={data?.drone}
        selected={false}
        onClick={() => {}}
        sx={{ marginTop: '16px'}}
      /> }

      <TakeOffPreflight 
        sx={{ marginTop: '24px', marginBottom: '24px'}}
        isAgree={open}
        toggleAgree={toggle} 
      />

      <TakeOffActions isAgree={open} droneSerial={data?.drone?.serialNumber ?? ''} orderId={data?.orders?.[0]?.id}/>

    </ArcStack>
  );
};

export default SidebarTakeOff;